module.exports = __webpack_public_path__ + "img/17.2dec5ed0.svg";